import React, { useEffect } from 'react';
import moment from 'moment';
import Image from 'next/image';
import logo from '../../../assets/fyllo.png';
import Link from 'next/link';
import MetaHead from '@/Components/MetaHead';
import parse from 'node-html-parser';
const { parse: rssParse } = require('rss-to-json');

// const fetchMediumBlogUrl = 'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@fyllotech';
const fetchMediumBlogUrl = 'https://medium.com/feed/@fyllo_jobs';

export default function Jobs({ JobList }) {
  const setThumbnail = (thumbnail) => {
    const popularImageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
    let imgSrc = '';
    if (popularImageExtensions.some((ext) => thumbnail.toLowerCase().endsWith(ext))) {
      imgSrc = thumbnail;
    } else {
      imgSrc = logo;
    }
    return imgSrc;
  };
  const ListParser = (text) => {
    const htmlDoc = parse(text);
    const listItems = htmlDoc?.querySelectorAll('h3');
    return listItems[0]?.textContent;
  };

  return (
    <div>
      <MetaHead title="Jobs | Fyllo" />
      <section className="px-4 md:mt-12 mx-auto max-w-screen-lg pt-6 md:pt-24 pb-10 lg:pt-[60px] lg:pb-20">
        <div className="container mx-auto">
          <div className="-mx-4 flex flex-wrap justify-center">
            <div className="w-full px-4">
              <div className=" mb-[40px] text-start lg:mb-20">
                <span className="text-green-700 mb-2 block text-lg font-semibold  py-1 rounded-full border-fyllo-800  max-w-max">
                  Available Jobs
                </span>
                <h2 className="my-4 md:my-8 text-2xl font-extrabold tracking-tight leading-none md:text-5xl text-fyllo-800  text-start">
                  Be part of our Mission
                </h2>
                <p className="text-body-color text-base max-w-screen-sm font-semibold">
                  We&apos;re looking for passionate people to join us on our mission. We value flat hierarchies, clear
                  communication, and full ownership and responsibility.
                </p>
              </div>
            </div>
          </div>
          <div className="-mx-4  grid">
            {JobList?.map((job, i) => {
              return (
                <div key={i} className="w-full px-4 border-b-2 border-b-gray-200">
                  <div className="w-full mb-10 ">
                    <div className="mb-8 overflow-hidden rounded">
                      {/* <Image
                        width={1600}
                        height={900}
                        src={setThumbnail(job?.thumbnail)}
                        // src="https://cdn-images-1.medium.com/v2/resize:fit:510/1*Aayk1JqR2bR8I1TukPKEVQ.jpeg"
                        alt="image"
                        className="w-full object-video"
                      /> */}
                    </div>
                    <div>
                      <div className="flex justify-between">
                        <h3 className="text-dark hover:text-green-700 mb-4 inline-block  font-semibold text-base sm:text-2xl lg:text-xl xl:text-2xl">
                          {job?.title}
                        </h3>
                        <div className="flex justify-between">
                          <Link href={'/careers/jobs/' + job?.title?.replace('/', '-')} className="mx-2">
                            <div className="text-sm md:text-base border-2 rounded-full px-4 py-1 hover:bg-fyllo-800 hover:text-white hover:border-fyllo-800">
                              See Details
                            </div>
                          </Link>
                          <Link href={{ pathname: '/careers/jobs/apply', query: { type: 'refer', job: job.title } }}>
                            <div className="text-sm md:text-base border-2 rounded-full px-4 py-1 hover:bg-fyllo-800 hover:text-white hover:border-fyllo-800">
                              Refer a friend
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <p className="text-sm md:text-base">{ListParser(job?.description)}</p>
                      </div>
                    </div>
                    <div className="flex gap-2 flex-wrap">
                      {job?.category?.map((cat, i) => {
                        return (
                          <div
                            key={'categories-' + i}
                            className="flex-auto min-w-min bg-slate-300 px-6 py-2 rounded-full max-w-max"
                          >
                            {cat}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })}
            <div></div>
          </div>
        </div>
      </section>
    </div>
  );
}

export async function getStaticProps() {

    const res = await rssParse(fetchMediumBlogUrl, {
      headers: {
       'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/110.0.0.0 Safari/537.36'
      }
   });
 
   const JobList = (res?.items || []).map(job => ({
     ...job,
     title: job.title,
     description: job?.description || job?.content || "",
   }));
   return {
     props: { JobList },
     revalidate: 60,
   };
}
